import { render, staticRenderFns } from "./HorizontalBarRanking.vue?vue&type=template&id=05f5bca9&"
import script from "./HorizontalBarRanking.vue?vue&type=script&lang=js&"
export * from "./HorizontalBarRanking.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalBarRanking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports